import { defineStore } from 'pinia';
import { useApiStore } from './API.module';

export const usePaymentLogsStore = defineStore('paymentLogs', {
  state: () => ({
    api: null,
    items: [],
    terminals: [],
    services: [],
    page: 0,
    rowsOnLastPage: 0,
    terminal: null,
    service: null
  }),

  actions: {
    async getLogs(data) {
      this.api = 'getLogs';
      try {
        data.page = this.page;
        const response = await useApiStore().send({ 
          method: 'post', 
          requestURL: '/payments/logs', 
          requestData: data 
        });
        this.page++;
        this.rowsOnLastPage = response.length;
        this.items = this.items.concat(response);
        this.api = 'success';
      } catch {
        this.api = null;
      }
    },
    init() {
      this.page = 0;
      this.rowsOnLastPage = 0;
      this.items = [];
    },
    async getTerminals(name) {
      try {
        this.terminals = await useApiStore().send({
          method: 'post',
          requestURL: '/terminals/getTerminalsByName',
          requestData: { name: name || undefined }
        });
      } catch {
        this.terminals = [];
      }
    },
    async getServices(name) {
        try {
          this.services = await useApiStore().send({
            method: 'post',
            requestURL: '/services/getservicesbyname',
            requestData: { name: name || undefined }
          });
        } catch {
          this.services = [];
        }
    }
  }
});
